import React, { useState, useEffect } from 'react';
import { Route, Navigate, useLocation, Routes } from 'react-router-dom';
import { hot } from 'react-hot-loader/root';
import { activeRoute } from './services/SpaService';
import { toast } from '@rickylandino/react-messages';
import Login from './components/Auth/Login';
import { Layout } from './components/Layout';
import Modal from 'react-modal';
import { Modal as AntModal } from 'antd';
import CustomerView from './components/Customers/CustomerView';
import CustomerSearch from './components/Search/CustomerSearch';
import Globals from "./config/globals";
import Dashboard from './components/Dashboard/Dashboard';
import DashboardWF from './components/Dashboard/DashboardWF';
import QueryBuilder from './components/ReportingOutput/QueryBuilder';
import QueryBuilderResults from './components/ReportingOutput/QueryBuilderResults';
import ManagementDashboard from './components/Management/ManagementDashboard';
import WidgetCallSheets from './components/Widgets/WidgetCallSheets';
//import { insertNewVersion } from './services/CachingService';
//import { getVersion } from './services/ApiService';
import AddJSSProspect from './components/Prospects/AddJSSProspect';
import SuppliedServicesMgr from './components/Shows/SuppliedServicesMgr';
import PendingSalesApprovals from './components/Sales/PendingSalesApprovals';
import Maintenance from './components/Maintenance/Maintenance';
import { checkHealth } from './config/health';

import { RecoilRoot } from 'recoil';

// How often the maintenance gate re-probes the API while it believes the DBs
// are down, so the app recovers on its own once service returns (issue #77).
const HEALTH_POLL_MS = 20000;

function App(props) {
    const location = useLocation();

    const [state, setState] = useState({
        refreshCache: false
    });

    // DB-down maintenance gate (issue #77).
    const [apiDown, setApiDown] = useState(false);

    useEffect(() => {
        activeRoute.next(location.pathname);

        Modal.setAppElement('#root');

        //getVersionInformation();

        AntModal.destroyAll();
    }, [location.pathname]);

    // Probe on startup, re-probe whenever the axios interceptor reports a
    // 503 / unreachable API, and poll while down so the app auto-recovers.
    useEffect(() => {
        let pollId = null;

        const stopPolling = () => {
            if (pollId) {
                clearInterval(pollId);
                pollId = null;
            }
        };

        const runHealthCheck = async () => {
            const healthy = await checkHealth();
            setApiDown(!healthy);

            if (healthy) {
                stopPolling();
            } else if (!pollId) {
                pollId = setInterval(runHealthCheck, HEALTH_POLL_MS);
            }
        };

        window.addEventListener('api-health-suspect', runHealthCheck);
        runHealthCheck();

        return () => {
            window.removeEventListener('api-health-suspect', runHealthCheck);
            stopPolling();
        };
    }, []);

    // hydrate Globals
    if (window.sessionStorage.getItem("userInfo")) {
        const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
        Globals.userInfo = userInfo;
    }

    const isAuthenticated = () => {
        const userInfo =
            Globals.userInfo && Globals.userInfo.userId
                ? Globals.userInfo
                : JSON.parse(sessionStorage.getItem("userInfo") || "{}");

        return !!userInfo?.userId;
    };

    //async function getVersionInformation() {
    //    let basePath = window.location.href;
    //    var baseUrl = basePath.replace(/\/+$/, '') + '/' + 'meta.json';

    //    const response = await fetch(baseUrl, {
    //        cache: 'no-store'
    //    });

    //    const meta = await response.json();

    //    getVersion().then(data => {
    //        if (`${meta.version}` !== data.cacheVersion) {
    //            toast.loading("Update in progress");
    //            setState({ refreshCache: true });

    //            insertNewVersion(meta.version).then(() => {
    //                props.emptyCache();
    //            });
    //        } else if (window.localStorage.APP_VERSION !== data.cacheVersion && !props.isLatestVersion) {
    //            toast.loading("Update in progress");
    //            setState({ refreshCache: true });

    //            props.emptyCache();
    //        }
    //    });
    //}

    // Gate everything (including the public Login route) behind the
    // maintenance page when the API can't reach its databases (issue #77).
    if (apiDown) {
        return <Maintenance />;
    }

    return (
        <div className="nav-function-top">
            <Routes>
                {/* Public route */}
                <Route path="/" element={<Login />} />

                {/* Protected routes */}
                <Route
                    path="/*"
                    element={
                        isAuthenticated() ? (
                            <RecoilRoot>
                                <Layout>
                                    <Routes>
                                        <Route path="/dashboard" element={<Dashboard />} />
                                        {/* <Route path="/dashboard" element={<DashboardWF />} /> */}
                                        <Route path="/customerview" element={<CustomerView />} />
                                        <Route path="/customersearch" element={<CustomerSearch />} />
                                        <Route path="/querybuilder" element={<QueryBuilder />} />
                                        <Route path="/queryresults" element={<QueryBuilderResults />} />
                                        <Route path="/management-dashboard" element={<ManagementDashboard />} />
                                        <Route path="/call-sheet-generator" element={<WidgetCallSheets />} />
                                        <Route path="/addprospect" element={<AddJSSProspect />} />
                                        <Route path="/supplied-services-manager" element={<SuppliedServicesMgr />} />
                                        <Route path="/pending-sales-approvals" element={<PendingSalesApprovals />} />

                                        {/* fallback */}
                                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                                    </Routes>
                                </Layout>
                            </RecoilRoot>
                        ) : (
                            <Navigate to="/" replace />
                        )
                    }
                />
            </Routes>

            {state.refreshCache && <div className="refresh-overlay" />}
        </div>
    );
}

export default process.env.NODE_ENV === "development" ? hot(App) : App;